import { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { useSetRecoilState } from "recoil";
import SaveToExeclButtonLayout from "../layout/SaveToExcelButtonLayout";
import apiClient from '../../lib/common/apiClient';
import notificationState from "../../states/notificationState";

function MomSysStockTakingDetailSaveExcelButton ( props ) {
    const {stockTakingId, onSuccess, onFailure, grid, view, ...others} = props;
    const { t } = useTranslation ();
    const setNotification = useSetRecoilState(notificationState);
    const [today, setToday] = useState();

    useEffect(() => {
        function settingToday() {
            let newDate = new Date();
            let year = newDate.getFullYear();
            let month = checkSingleNumber((newDate.getMonth() + 1));
            let date = checkSingleNumber(newDate.getDate());
            let today = year + "/" + month + "/" + date;
            setToday(today);
        }

        function checkSingleNumber(value) {
            if(value < 10) {
                return "0" + value;
            }
            return value;
        }

        settingToday();
    }, []);

    const successNotification = (result) => {
        setNotification({
            severity : "success",
            msg : t("success.fileDownloadSuccess"),
            open : true
        });
    };

    const failureNotification = (reason) => {
        setNotification({
            severity : "error",
            msg : t("error.fileDownloadFailure", {reason: reason.response ? reason.response.data : reason}),
            open : true
        });
    };

    const doHandleFileStream = (result) => {
        const targetFileName = today + ' 재고 조사.xlsx';
        
        const blob = new Blob([result.data]);
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = targetFileName;
        link.click();
        window.URL.revokeObjectURL(link.href);
    };

    const onSaveToExcel = () => {
        const url = `/api/MomSysUglStockTakingDetail/${stockTakingId}/excel`;

        apiClient
            .get(url, { responseType: "blob" })
            .then((result) => {
                doHandleFileStream(result);
                successNotification(result);
            })
            .catch((reason) => failureNotification(reason));
    }

    return (
        <>
            <SaveToExeclButtonLayout id={"save-to-execl-button"} color="primary" onClick = {onSaveToExcel} {...others}/>
        </>
    );
}

export default MomSysStockTakingDetailSaveExcelButton;
